Ext.define('SA.view.sidebar.Tabs', {
    alias: 'widget.sidebar-tabs',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-sidebar-tabs',

    initComponent() {
        this.items = [
            {
                xtype: 'sidebar-tab',
                type: 'locations',
                label: 'Locations',
                iconHref: '#sa-icon-locations'
            }, {
                xtype: 'sidebar-tab',
                type: 'data',
                label: 'Data',
                iconHref: '#sa-icon-data'
            }, {
                xtype: 'sidebar-tab',
                type: 'businesses',
                label: 'Businesses',
                iconHref: '#sa-icon-businesses'
            }
        ];

        this.callParent();
    },

    initEvents() {
        this.callParent();

        this.eachTab(tab => tab.on('click', this.onTabClick, this));
        this.eachTab(tab => tab.on('mouseover', this.onTabMouseover, this));
    },

    eachTab(callback) {
        this.items.forEach(tab => callback(tab));
    },

    hasSelectedTab() {
        return this.items.some(item => item.isSelected());
    },

    onTabClick(type) {
        this.fireEvent('click:tab', type);
    },

    onTabMouseover(tab) {
        this.fireEvent('mouseover:tab', tab);
    },

    setEnabledTypes(enabledTypes) {
        this.eachTab(tab => tab.setEnabled(tab.hasType(enabledTypes)));
    },

    setSelectedType(selectedType) {
        this.eachTab(tab => tab.setSelected(tab.hasType(selectedType)));
    }
});